import { Component } from '@angular/core';
import { ItemListContainerBase } from '@fi-app/core/item-list-container-base';

@Component({
    selector: 'fi-role-list-container',
    template: `<fi-role-list></fi-role-list>`,
    styleUrls: ['./role-list-container.component.scss'],
    standalone: false,
})
export class RoleListContainerComponent extends ItemListContainerBase {}
